// extracted by mini-css-extract-plugin
export default {"introductionSection":"Introduction_introductionSection__9uxGl"};